import React, { useState } from "react";

export default function TodoItem({ task, toggleComplete, editTask, deleteTask, updateDueDate, updatePriority }) {
  const [isEditing, setIsEditing] = useState(false);
  const [newText, setNewText] = useState(task.text);

  const saveEdit = () => {
    if (newText.trim()) {
      editTask(task.id, newText);
      setIsEditing(false);
    }
  };

  return (
    <div className={`todo-item ${task.completed ? "completed" : ""}`}>
      {isEditing ? (
        <>
          <input type="text" value={newText} onChange={(e) => setNewText(e.target.value)} />
          <button onClick={saveEdit}>Save</button>
        </>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <span onClick={() => toggleComplete(task.id)}>{task.text}</span>
            {task.priority && <span className={`priority ${task.priority.toLowerCase()}`}>{task.priority}</span>}
          </div>
          {task.dueDate && (
            <small className="due-date">⏰ {new Date(task.dueDate).toLocaleString()}</small>
          )}
        </>
      )}

      <div className="actions">
        <button onClick={() => setIsEditing(!isEditing)}>✏️</button>
        <button onClick={() => deleteTask(task.id)}>🗑️</button>
      </div>

      <div className="due-edit" style={{ marginTop: '5px', display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
        <input type="datetime-local" value={task.dueDate || ""} onChange={(e) => updateDueDate(task.id, e.target.value)} />
        <select value={task.priority || ""} onChange={(e) => updatePriority(task.id, e.target.value)} style={{ padding: '5px', borderRadius: '6px', border: '1px solid #ccc' }}>
          <option value="">Priority</option>
          <option value="High">High</option>
          <option value="Medium">Medium</option>
          <option value="Low">Low</option>
        </select>
      </div>
    </div>
  );
}
